import axios from "axios";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { UserContext } from "../context/index";

const useCreatePayloadAndJoinLobby = (loginData: any) 
    : [(email: string, fullName: string, nickname: string) => void] => {
    const { createUser, joinTeamLobby} = useContext(UserContext);
    
    const { t } = useTranslation();
    let history = useHistory();
    const windowLocationHref = window.location.href;
    const urlPathChunks = windowLocationHref.split("/");
    const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];

    const createPayloadAndJoinRandomLobby = (email: string, fullName: string, nickname: string) =>{

      axios({
        method: "post",
        url: process.env.REACT_APP_ADMIN_BACKEND_URL + "api/preactive-matches/get-match-data/",
        
        // url: process.env.REACT_APP_ADMIN_BACKEND_URL + "api/preactive-matches/get-match-data/",
        
        // url: "http://admin-api.uppiness.marbleit.rs/api/preactive-matches/get-match-data/",
        data:{
          id: urlTokenExtracted
        }
      })
      .then((res) => {
        if (res.data) {
          if(res.data._doc.isMatchFinished[0].isFinished) {
            alert(t('gameAlreadyFinishedText'));
          } else {
            let payload = {
              matchId: urlTokenExtracted,
              gameId: 1,
              preactive: res.data,
              player: {
                email,
                fullName: fullName,
                nickname: nickname,
              },
            };
              createUser(loginData);
              joinTeamLobby(payload);
              history.push("/lobby/" + urlTokenExtracted);
          }


        }
      })
      .catch((err: any) => {});
    }

    return [createPayloadAndJoinRandomLobby];
}

export default useCreatePayloadAndJoinLobby;